//
//  ******* Fetch Related *******
//

export const COMPANY_PROFILE_UPDATE_FETCH_BEGIN = "COMPANY_PROFILE_UPDATE_FETCH_BEGIN";
export const COMPANY_PROFILE_UPDATE_FETCH_SUCCESS = "COMPANY_PROFILE_UPDATE_FETCH_SUCCESS";
export const COMPANY_PROFILE_UPDATE_FETCH_FAIL = "COMPANY_PROFILE_UPDATE_FETCH_FAIL";
export const COMPANY_PROFILE_UPDATE_START_REVISE = "COMPANY_PROFILE_UPDATE_START_REVISE";
export const COMPANY_PROFILE_UPDATE_NO_REVISE = "COMPANY_PROFILE_UPDATE_NO_REVISE";


//
//  ******* PUT Related *******
//

export const COMPANY_PROFILE_UPDATE_BEGIN = "COMPANY_PROFILE_UPDATE_BEGIN";
export const COMPANY_PROFILE_UPDATE_SUCCESS = "COMPANY_PROFILE_UPDATE_SUCCESS";
export const COMPANY_PROFILE_UPDATE_UPLOAD_SUCCESS = "COMPANY_PROFILE_UPDATE_UPLOAD_SUCCESS";
export const COMPANY_PROFILE_UPDATE_FAIL = "COMPANY_PROFILE_UPDATE_FAIL";

//
//  ******* Company Document Upload ******
//

export const COMPANY_PROFILE_DOCUMENT_UPLOAD_BEGIN = "COMPANY_PROFILE_DOCUMENT_UPLOAD_BEGIN";
export const COMPANY_PROFILE_DOCUMENT_UPLOAD_SUCCESS = "COMPANY_PROFILE_DOCUMENT_UPLOAD_SUCCESS";
export const COMPANY_PROFILE_DOCUMENT_UPLOAD_FAIL = "COMPANY_PROFILE_DOCUMENT_UPLOAD_FAIL";

//
//  ******* Company Document Remove ******
//

export const COMPANY_PROFILE_DOCUMENT_REMOVE_BEGIN = "COMPANY_PROFILE_DOCUMENT_REMOVE_BEGIN";
export const COMPANY_PROFILE_DOCUMENT_REMOVE_SUCCESS = "COMPANY_PROFILE_DOCUMENT_REMOVE_SUCCESS";
export const COMPANY_PROFILE_DOCUMENT_REMOVE_FAIL = "COMPANY_PROFILE_DOCUMENT_REMOVE_FAIL";

//
//  ******* PRIVACY RELATED ******

export const PRIVACY_FIELD_UPDATE_PUT_BEGIN = "PRIVACY_FIELD_UPDATE_PUT_BEGIN";
export const PRIVACY_FIELD_UPDATE_PUT_SUCCESS = "PRIVACY_FIELD_UPDATE_PUT_SUCCESS";
export const PRIVACY_FIELD_UPDATE_PUT_FAIL = "PRIVACY_FIELD_UPDATE_PUT_FAIL";

//
//  ******* Fetch Buyer Related *******
//

export const BUYER_PROFILE_FETCH_BEGIN = "BUYER_PROFILE_FETCH_BEGIN";
export const BUYER_PROFILE_FETCH_SUCCESS = "BUYER_PROFILE_FETCH_SUCCESS";
export const BUYER_PROFILE_FETCH_FAIL = "BUYER_PROFILE_FETCH_FAIL";

//
//  ******* Fetch Related *******
//

export const MANAGER_SUPPLIER_PROFILE_FETCH_BEGIN = "MANAGER_SUPPLIER_PROFILE_FETCH_BEGIN";
export const MANAGER_SUPPLIER_PROFILE_FETCH_SUCCESS = "MANAGER_SUPPLIER_PROFILE_FETCH_SUCCESS";
export const MANAGER_PROFILE_EDIT_TAGS_INIT = "MANAGER_PROFILE_EDIT_TAGS_INIT";
export const MANAGER_SUPPLIER_PROFILE_FETCH_FAIL = "MANAGER_SUPPLIER_PROFILE_FETCH_FAIL";

export const MANAGER_SUPPLIER_PROFILE_BEGIN = "MANAGER_SUPPLIER_PROFILE_BEGIN";
export const MANAGER_SUPPLIER_PROFILE_SUCCESS = "MANAGER_SUPPLIER_PROFILE_SUCCESS";
export const MANAGER_SUPPLIER_PROFILE_UPLOAD_SUCCESS = "MANAGER_SUPPLIER_PROFILE_UPLOAD_SUCCESS";
export const MANAGER_SUPPLIER_PROFILE_FAIL = "MANAGER_SUPPLIER_PROFILE_FAIL";

export const MANAGER_SUPPLIER_CLASSIFICATION_PUT_BEGIN = "MANAGER_SUPPLIER_CLASSIFICATION_PUT_BEGIN";
export const MANAGER_SUPPLIER_CLASSIFICATION_PUT_SUCCESS = "MANAGER_SUPPLIER_CLASSIFICATION_PUT_SUCCESS";
export const MANAGER_SUPPLIER_CLASSIFICATION_PUT_FAIL = "MANAGER_SUPPLIER_CLASSIFICATION_PUT_FAIL";

// ******* Delete Profile Photos Related ***********

export const COMPANY_PROFILE_DELETE_PHOTOS_BEGIN = "COMPANY_PROFILE_DELETE_PHOTOS_BEGIN";
export const COMPANY_PROFILE_DELETE_PHOTOS_SUCCESS = "COMPANY_PROFILE_DELETE_PHOTOS_SUCCESS";
export const COMPANY_PROFILE_DELETE_PHOTOS_FAIL = "COMPANY_PROFILE_DELETE_PHOTOS_FAIL";

// ******* Delete Cert Related ***********
export const COMPANY_PROFILE_CERT_DELETE = "COMPANY_PROFILE_CERT_DELETE";

//
//  ******* Manager Supplier Assign Tags  *******
//

export const COMPANY_PROFILE_HANDLE_TAGS_BEGIN = "COMPANY_PROFILE_HANDLE_TAGS_BEGIN";
export const COMPANY_PROFILE_HANDLE_TAGS_SUCCESS = "COMPANY_PROFILE_HANDLE_TAGS_SUCCESS";
export const COMPANY_PROFILE_HANDLE_TAGS_FAIL = "COMPANY_PROFILE_HANDLE_TAGS_FAIL";

//
//  ******* Manager Supplier Document Update (expiryDate + remark)  *******
//

export const MANAGER_SUPPLIER_DOCUMENT_UPDATE_BEGIN = "MANAGER_SUPPLIER_DOCUMENT_UPDATE_BEGIN";
export const MANAGER_SUPPLIER_DOCUMENT_UPDATE_SUCCESS = "MANAGER_SUPPLIER_DOCUMENT_UPDATE_SUCCESS";
export const MANAGER_SUPPLIER_DOCUMENT_UPDATE_FAIL = "MANAGER_SUPPLIER_DOCUMENT_UPDATE_FAIL";

//
//  ******* Company/Supplier - Update Profile Strength *******
//

export const COMPANY_PROFILE_STRENGTH_UPDATE_BEGIN = "COMPANY_PROFILE_STRENGTH_UPDATE_BEGIN";
export const COMPANY_PROFILE_STRENGTH_UPDATE_SUCCESS = "COMPANY_PROFILE_STRENGTH_UPDATE_SUCCESS";
export const COMPANY_PROFILE_STRENGTH_UPDATE_FAIL = "COMPANY_PROFILE_STRENGTH_UPDATE_FAIL";
